import { createVNode } from 'vue';

function text(children, classes, style, fictionalClasses, fictionalStyle) {
  return createVNode("span", {
    "class": classes ? `se-text ${classes.join(' ')}` : 'se-text',
    "style": style
  }, [createVNode("span", {
    "class": fictionalClasses ? `se-fictional-text ${fictionalClasses.join(' ')}` : 'se-fictional-text',
    "contenteditable": "false",
    "data-text": "{",
    "style": fictionalStyle
  }, null), children, createVNode("span", {
    "class": fictionalClasses ? `se-fictional-text ${fictionalClasses.join(' ')}` : 'se-fictional-text',
    "contenteditable": "false",
    "data-text": "}",
    "style": fictionalStyle
  }, null)]);
}

export { text };
//# sourceMappingURL=text.js.map
